<mat-horizontal-stepper [linear]="true" #stepper>
  <!-- Step 1: Project Identification -->
  <mat-step [stepControl]="basicForm">
    <form [formGroup]="basicForm">
      <ng-template matStepLabel>Basic Details</ng-template>

      <div class="form-row">
        <div class="half-width">
          <mat-label>Title</mat-label>

          <mat-form-field appearance="outline">
            <input matInput formControlName="title" maxlength="100" />
            <mat-error *ngIf="basicForm.get('title')?.hasError('required')">
              Title is required
            </mat-error>
            <mat-error *ngIf="basicForm.get('title')?.hasError('maxlength')">
              Maximum 100 characters allowed
            </mat-error>
          </mat-form-field>
        </div>
        <div class="half-width">
          <mat-label>Quote Number</mat-label>

          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="quoteNumber" />
            <mat-error *ngIf="basicForm.get('quoteNumber')?.hasError('pattern')">
              Only uppercase letters, numbers, and hyphens allowed
            </mat-error>
          </mat-form-field>
        </div>
        <div class="half-width">
          <mat-label>Valid Until</mat-label>

          <mat-form-field appearance="outline" class="half-width">
            <input matInput [matDatepicker]="validPicker" formControlName="validUntil" />
            <mat-datepicker-toggle matSuffix [for]="validPicker"></mat-datepicker-toggle>
            <mat-datepicker #validPicker></mat-datepicker>
            <mat-error *ngIf="basicForm.get('validUntil')?.hasError('required')">
              Valid until date is required
            </mat-error>
          </mat-form-field>
        </div>
        <div class="half-width">
          <mat-label>Assigned To</mat-label>

          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="assignedTo" maxlength="100" />
            <mat-error *ngIf="basicForm.get('assignedTo')?.hasError('maxlength')">
              Maximum 100 characters allowed
            </mat-error>
          </mat-form-field>
        </div>
        <div class="half-width">
          <mat-label>Approval Status</mat-label>

          <mat-form-field appearance="outline" class="half-width">
            <mat-select formControlName="approvalStatus">
              <mat-option value="">None</mat-option>
              <mat-option value="Approved">Approved</mat-option>
              <mat-option value="Rejected">Rejected</mat-option>
              <mat-option value="Pending">Pending</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="half-width">
          <mat-label>Opportunity</mat-label>

          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="opportunity" maxlength="150" />
            <mat-error *ngIf="basicForm.get('opportunity')?.hasError('maxlength')">
              Maximum 150 characters allowed
            </mat-error>
          </mat-form-field>
        </div>
        <div class="half-width">
          <mat-label>Quote Stage</mat-label>

          <mat-form-field appearance="outline" class="half-width">
            <mat-select formControlName="quoteStage">
              <mat-option value="Draft">Draft</mat-option>
              <mat-option value="Submitted">Submitted</mat-option>
              <mat-option value="Approved">Approved</mat-option>
              <mat-option value="Finalized">Finalized</mat-option>
            </mat-select>
            <mat-error *ngIf="basicForm.get('quoteStage')?.hasError('required')">
              Quote stage is required
            </mat-error>
          </mat-form-field>
        </div>
        <div class="half-width">
          <mat-label>Invoice Status</mat-label>

          <mat-form-field appearance="outline" class="half-width">
            <mat-select formControlName="invoiceStatus">
              <mat-option value="Not Invoiced">Not Invoiced</mat-option>
              <mat-option value="Partially Invoiced">Partially Invoiced</mat-option>
              <mat-option value="Fully Invoiced">Fully Invoiced</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="half-width">
          <mat-label>Payment Terms</mat-label>

          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="paymentTerms" maxlength="100" />
            <mat-error *ngIf="basicForm.get('paymentTerms')?.hasError('maxlength')">
              Maximum 100 characters allowed
            </mat-error>
          </mat-form-field>
        </div>
        <div class="full-width">
          <mat-label>Approval Issues</mat-label>

          <mat-form-field appearance="outline">
            <textarea matInput formControlName="approvalIssues" maxlength="500" rows="3"></textarea>
            <mat-error *ngIf="basicForm.get('approvalIssues')?.hasError('maxlength')">
              Maximum 500 characters allowed
            </mat-error>
          </mat-form-field>
        </div>

      </div>

      <div class="form-actions">
        <button mat-raised-button color="primary" matStepperNext [disabled]="!basicForm.valid">Next</button>
      </div>
    </form>

  </mat-step>
  <mat-step [stepControl]="addressForm">
    <form [formGroup]="addressForm">
      <ng-template matStepLabel>Address Info</ng-template>

      <div class="form-row">
        <div class="half-width">
          <mat-label>Account</mat-label>

          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="account" maxlength="100" />
            <mat-error *ngIf="addressForm.get('account')?.hasError('maxlength')">
              Max 100 characters allowed
            </mat-error>
          </mat-form-field>
        </div>
        <div class="half-width">
          <mat-label>Contact</mat-label>

          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="contact" maxlength="100" />
            <mat-error *ngIf="addressForm.get('contact')?.hasError('maxlength')">
              Max 100 characters allowed
            </mat-error>
          </mat-form-field>
        </div>

        <div formGroupName="billingAddress" class="full-width">

          <h3 class="section-title">Billing Address</h3>

          <div class="form-row">
            <div class="half-width">
              <mat-label>Street</mat-label>

              <mat-form-field appearance="outline" class="half-width">
                <input matInput formControlName="street" maxlength="100" />
                <mat-error *ngIf="addressForm.get('billingAddress.street')?.hasError('maxlength')">
                  Max 100 characters allowed
                </mat-error>
              </mat-form-field>
            </div>
            <div class="half-width">
              <mat-label>City</mat-label>

              <mat-form-field appearance="outline" class="half-width">
                <input matInput formControlName="city" maxlength="50" />
                <mat-error *ngIf="addressForm.get('billingAddress.city')?.hasError('maxlength')">
                  Max 50 characters allowed
                </mat-error>
              </mat-form-field>
            </div>
            <div class="half-width">
              <mat-label>State</mat-label>

              <mat-form-field appearance="outline" class="half-width">
                <input matInput formControlName="state" maxlength="50" />
                <mat-error *ngIf="addressForm.get('billingAddress.state')?.hasError('maxlength')">
                  Max 50 characters allowed
                </mat-error>
              </mat-form-field>
            </div>
            <div class="half-width">
              <mat-label>Postal Code</mat-label>

              <mat-form-field appearance="outline" class="half-width">
                <input matInput formControlName="postalCode" />
                <mat-error *ngIf="addressForm.get('billingAddress.postalCode')?.hasError('pattern')">
                  Postal code must be 5 to 10 digits
                </mat-error>
              </mat-form-field>
            </div>
            <div class="half-width">
              <mat-label>Country</mat-label>

              <mat-form-field appearance="outline" class="half-width">
                <input matInput formControlName="country" maxlength="50" />
                <mat-error *ngIf="addressForm.get('billingAddress.country')?.hasError('maxlength')">
                  Max 50 characters allowed
                </mat-error>
              </mat-form-field>
            </div>
          </div>

        </div>

      </div>
      <div class="form-actions">
        <button mat-button matStepperPrevious>Back</button>
        <button mat-raised-button color="primary" matStepperNext [disabled]="!addressForm.valid">Next</button>
      </div>
    </form>

  </mat-step>
  <mat-step [stepControl]="  financialForm ">
    <form [formGroup]="financialForm">
      <ng-template matStepLabel>Financial Info</ng-template>

      <div class="form-row">
        <div class="half-width">
          <mat-label>Currency</mat-label>

        <mat-form-field appearance="outline" class="half-width">
          <mat-select formControlName="currency">
            <mat-option value="USD">USD</mat-option>
            <mat-option value="INR">INR</mat-option>
            <mat-option value="EUR">EUR</mat-option>
          </mat-select>
          <mat-error *ngIf="financialForm.get('currency')?.hasError('required')">
            Currency is required
          </mat-error>
        </mat-form-field>
        </div>
        <div class="half-width">
          <mat-label>Total</mat-label>

        <mat-form-field appearance="outline" class="half-width">
          <input matInput formControlName="total" />
          <mat-error *ngIf="financialForm.get('total')?.hasError('pattern')">
            Invalid amount (up to 2 decimal places)
          </mat-error>
        </mat-form-field>
        </div>
        <div class="half-width">
          <mat-label>Discount</mat-label>

        <mat-form-field appearance="outline" class="half-width">
          <input matInput formControlName="discount" />
          <mat-error *ngIf="financialForm.get('discount')?.hasError('pattern')">
            Invalid discount format
          </mat-error>
        </mat-form-field>
        </div>
        <div class="half-width">
          <mat-label>Subtotal</mat-label>

        <mat-form-field appearance="outline" class="half-width">
          <input matInput formControlName="subtotal" />
          <mat-error *ngIf="financialForm.get('subtotal')?.hasError('pattern')">
            Invalid subtotal format
          </mat-error>
        </mat-form-field>
        </div>
        <div class="half-width">
          <mat-label>Shipping</mat-label>

        <mat-form-field appearance="outline" class="half-width">
          <input matInput formControlName="shipping" />
          <mat-error *ngIf="financialForm.get('shipping')?.hasError('pattern')">
            Invalid shipping format
          </mat-error>
        </mat-form-field>
        </div>
        <div class="half-width">
          <mat-label>Shipping Tax</mat-label>

        <mat-form-field appearance="outline" class="half-width">
          <input matInput formControlName="shippingTax" />
          <mat-error *ngIf="financialForm.get('shippingTax')?.hasError('required')">
            Shipping tax is required
          </mat-error>
        </mat-form-field>
        </div>
        <div class="half-width">
          <mat-label>Tax</mat-label>

        <mat-form-field appearance="outline" class="half-width">
          <input matInput formControlName="tax" />
          <mat-error *ngIf="financialForm.get('tax')?.hasError('pattern')">
            Invalid tax format
          </mat-error>
        </mat-form-field>
        </div>
        <div class="half-width">
          <mat-label>Grand Total</mat-label>

        <mat-form-field appearance="outline" class="half-width">
          <input matInput formControlName="grandTotal" />
          <mat-error *ngIf="financialForm.get('grandTotal')?.hasError('pattern')">
            Invalid grand total format
          </mat-error>
        </mat-form-field>
        </div>

      </div>
      <div class="form-actions">
        <button mat-button matStepperPrevious>Back</button>
        <button mat-raised-button color="primary" matStepperNext [disabled]="!financialForm.valid">Next</button>
      </div>
    </form>

  </mat-step>
</mat-horizontal-stepper>



<!-- <form [formGroup]="quoteForm" (ngSubmit)="onSubmit()" class="p-6 space-y-8 bg-white rounded-xl shadow-lg">

  <fieldset class="grid grid-cols-1 md:grid-cols-2 gap-6">
    <legend class="text-lg font-semibold text-gray-700 mb-2">Quote Overview</legend>

    <mat-form-field appearance="outline">
      <mat-label>Title *</mat-label>
      <input matInput formControlName="title" />
      <mat-error *ngIf="quoteForm.get('title')?.touched && quoteForm.get('title')?.invalid">
        Title is required and should not exceed 100 characters.
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Opportunity</mat-label>
      <input matInput formControlName="opportunity" />
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Quote Number</mat-label>
      <input matInput formControlName="quoteNumber" />
      <mat-error *ngIf="quoteForm.get('quoteNumber')?.touched && quoteForm.get('quoteNumber')?.invalid">
        Number is not valid.
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Quote Stage *</mat-label>
      <mat-select formControlName="quoteStage">
        <mat-option value="Draft">Draft</mat-option>
        <mat-option value="Negotiation">Negotiation</mat-option>
        <mat-option value="Final">Final</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Valid Until *</mat-label>
      <input matInput [min]="cValue" formControlName="validUntil" type="date" />
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Invoice Status</mat-label>
      <input matInput formControlName="invoiceStatus" />
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Assigned To</mat-label>
      <input matInput formControlName="assignedTo" />
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Payment Terms</mat-label>
      <input matInput formControlName="paymentTerms" />
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Approval Status</mat-label>
      <input matInput formControlName="approvalStatus" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="md:col-span-2">
      <mat-label>Approval Issues</mat-label>
      <textarea matInput formControlName="approvalIssues" rows="3"></textarea>
    </mat-form-field>
  </fieldset>

  <fieldset class="grid grid-cols-1 md:grid-cols-2 gap-6">
    <legend class="text-lg font-semibold text-gray-700 mb-2">Address Information</legend>

    <div>
      <mat-form-field appearance="outline" class="w-full">
        <mat-label>Account</mat-label>
        <input matInput formControlName="account" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-full mt-4">
        <mat-label>Contact</mat-label>
        <input matInput formControlName="contact" />
      </mat-form-field>

      <div formGroupName="billingAddress" class="mt-6">
        <h4 class="font-semibold text-gray-700 mb-2">Billing Address</h4>
        <ng-container *ngFor="let field of ['street', 'city', 'state', 'postalCode', 'country']">
          <mat-form-field appearance="outline" class="w-full mb-2">
            <mat-label>{{ field | titlecase }}</mat-label>
            <input matInput [formControlName]="field" />
          </mat-form-field>
        </ng-container>
      </div>
    </div>

    <div formGroupName="shippingAddress" class="mt-6 md:mt-0">
      <h4 class="font-semibold text-gray-700 mb-2">Shipping Address</h4>
      <ng-container *ngFor="let field of ['street', 'city', 'state', 'postalCode', 'country']">
        <mat-form-field appearance="outline" class="w-full mb-2">
          <mat-label>{{ field | titlecase }}</mat-label>
          <input matInput [formControlName]="field" />
        </mat-form-field>
      </ng-container>
    </div>
  </fieldset>

  <fieldset class="grid grid-cols-1 md:grid-cols-2 gap-6">
    <legend class="text-lg font-semibold text-gray-700 mb-2">Financial Summary</legend>

    <mat-form-field appearance="outline">
      <mat-label>Currency</mat-label>
      <mat-select formControlName="currency">
        <mat-option value="USD">US Dollar</mat-option>
        <mat-option value="INR">Indian Rupee</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Total</mat-label>
      <input matInput formControlName="total" />
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Discount</mat-label>
      <input matInput formControlName="discount" />
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Subtotal</mat-label>
      <input matInput formControlName="subtotal" />
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Shipping</mat-label>
      <input matInput formControlName="shipping" />
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Shipping Tax</mat-label>
      <mat-select formControlName="shippingTax">
        <mat-option value="0%">0%</mat-option>
        <mat-option value="5%">5%</mat-option>
        <mat-option value="18%">18%</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Tax</mat-label>
      <input matInput formControlName="tax" />
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Grand Total</mat-label>
      <input matInput formControlName="grandTotal" />
    </mat-form-field>
  </fieldset>

  <div class="text-right pt-4">
    <button mat-raised-button color="primary" type="submit" [disabled]="quoteForm.invalid">
      Save Quote
    </button>
  </div>
</form> -->